import { NgModule } from '@angular/core';

import { LoginComponent } from './login.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivationComponent } from '../activation/activation.component';
import {AdsComponent} from "./ads/ads.component";

const routes: Routes = [
    { path: 'a/:id', component: LoginComponent },
    { path: '', component: LoginComponent },
]

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        RouterModule.forChild(routes),
        ReactiveFormsModule,
        ActivationComponent,
        AdsComponent,
    ],
    exports: [],
    declarations: [LoginComponent],
    providers: [],
})
export class LoginModule { }
